import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, Area, AreaChart } from 'recharts';
import { ChevronRight, Clock, TrendingUp, TrendingDown, AlertTriangle, CheckCircle, User, Calendar, Timer, Gamepad2 } from 'lucide-react';
import { GENERAL } from "../general/General";
const ChessAnalysisDisplay = ({updateBackground}) => {
  const [activeTab, setActiveTab] = useState('confidence');

   useEffect(() => {
        updateBackground({
          image: GENERAL.BACKGROUND,
        });
        
      }, [updateBackground]);

  // Game data from Claude API
  const gameData = {
    gameMetadata: {
      gameId: "2f1ef6a0-d7a3-498d-80ed-e89820f0c83a",
      whitePlayer: "Daniel Galitzky (work)",
      blackPlayer: "Jessica Müller",
      opening: "Защита Каро-Канн, вариант с 2.c4",
      result: "Белые выиграли матом",
      totalMoves: 41,
      gameType: "30 минут на партию",
      startTime: "2025-07-05 20:01:51",
      endTime: "2025-07-05 20:19:49",
      duration: "17:58",
      userType: "Human",
      opponentType: "Human",
      usedHints: 0,
      gameStatus: "white_won_by_mat_black"
    },
    statistics: {
      whiteAccuracy: 85,
      blackAccuracy: 68,
      totalMoves: 41,
      criticalErrors: 3,
      averageWhiteTime: 7.5,
      averageBlackTime: 16.8,
      longestThink: {
        player: "black",
        move: 13,
        time: 97,
        description: "Длительное размышление над позицией после потери пешки g7"
      }
    },
    moveData: [
      { move: 1, whiteTime: 5, blackTime: 2, whiteConfidence: 95, blackConfidence: 90, whiteStress: 10, blackStress: 15, whiteAccuracy: 90, blackAccuracy: 85 },
      { move: 2, whiteTime: 9, blackTime: 2, whiteConfidence: 88, blackConfidence: 85, whiteStress: 15, blackStress: 20, whiteAccuracy: 88, blackAccuracy: 80 },
      { move: 3, whiteTime: 6, blackTime: 3, whiteConfidence: 85, blackConfidence: 82, whiteStress: 18, blackStress: 22, whiteAccuracy: 85, blackAccuracy: 82 },
      { move: 4, whiteTime: 7, blackTime: 9, whiteConfidence: 82, blackConfidence: 78, whiteStress: 20, blackStress: 25, whiteAccuracy: 82, blackAccuracy: 75 },
      { move: 5, whiteTime: 9, blackTime: 9, whiteConfidence: 80, blackConfidence: 75, whiteStress: 22, blackStress: 28, whiteAccuracy: 80, blackAccuracy: 72 },
      { move: 6, whiteTime: 10, blackTime: 10, whiteConfidence: 78, blackConfidence: 70, whiteStress: 25, blackStress: 35, whiteAccuracy: 75, blackAccuracy: 68 },
      { move: 7, whiteTime: 9, blackTime: 29, whiteConfidence: 82, blackConfidence: 65, whiteStress: 20, blackStress: 40, whiteAccuracy: 82, blackAccuracy: 65 },
      { move: 8, whiteTime: 9, blackTime: 19, whiteConfidence: 85, blackConfidence: 60, whiteStress: 18, blackStress: 45, whiteAccuracy: 85, blackAccuracy: 60 },
      { move: 9, whiteTime: 9, blackTime: 14, whiteConfidence: 88, blackConfidence: 55, whiteStress: 15, blackStress: 50, whiteAccuracy: 88, blackAccuracy: 55 },
      { move: 10, whiteTime: 9, blackTime: 20, whiteConfidence: 92, blackConfidence: 45, whiteStress: 12, blackStress: 60, whiteAccuracy: 92, blackAccuracy: 40 },
      { move: 11, whiteTime: 6, blackTime: 2, whiteConfidence: 95, blackConfidence: 40, whiteStress: 8, blackStress: 65, whiteAccuracy: 95, blackAccuracy: 38 },
      { move: 12, whiteTime: 8, blackTime: 3, whiteConfidence: 93, blackConfidence: 35, whiteStress: 10, blackStress: 70, whiteAccuracy: 93, blackAccuracy: 35 },
      { move: 13, whiteTime: 8, blackTime: 97, whiteConfidence: 90, blackConfidence: 25, whiteStress: 12, blackStress: 80, whiteAccuracy: 90, blackAccuracy: 25 },
      { move: 14, whiteTime: 9, blackTime: 31, whiteConfidence: 94, blackConfidence: 20, whiteStress: 8, blackStress: 85, whiteAccuracy: 94, blackAccuracy: 20 },
      { move: 15, whiteTime: 8, blackTime: 26, whiteConfidence: 96, blackConfidence: 18, whiteStress: 6, blackStress: 88, whiteAccuracy: 96, blackAccuracy: 18 },
      { move: 16, whiteTime: 6, blackTime: 16, whiteConfidence: 94, blackConfidence: 15, whiteStress: 8, blackStress: 90, whiteAccuracy: 94, blackAccuracy: 15 },
      { move: 17, whiteTime: 7, blackTime: 27, whiteConfidence: 92, blackConfidence: 12, whiteStress: 10, blackStress: 92, whiteAccuracy: 92, blackAccuracy: 12 },
      { move: 18, whiteTime: 9, blackTime: 36, whiteConfidence: 95, blackConfidence: 10, whiteStress: 8, blackStress: 95, whiteAccuracy: 95, blackAccuracy: 10 },
      { move: 19, whiteTime: 8, blackTime: 9, whiteConfidence: 96, blackConfidence: 8, whiteStress: 6, blackStress: 96, whiteAccuracy: 96, blackAccuracy: 8 },
      { move: 20, whiteTime: 8, blackTime: 6, whiteConfidence: 97, blackConfidence: 6, whiteStress: 5, blackStress: 97, whiteAccuracy: 97, blackAccuracy: 6 },
      { move: 21, whiteTime: 6, blackTime: 23, whiteConfidence: 95, blackConfidence: 5, whiteStress: 7, blackStress: 98, whiteAccuracy: 95, blackAccuracy: 5 },
      { move: 22, whiteTime: 9, blackTime: 3, whiteConfidence: 98, blackConfidence: 4, whiteStress: 4, blackStress: 98, whiteAccuracy: 98, blackAccuracy: 4 },
      { move: 23, whiteTime: 9, blackTime: 17, whiteConfidence: 97, blackConfidence: 3, whiteStress: 5, blackStress: 99, whiteAccuracy: 97, blackAccuracy: 3 },
      { move: 24, whiteTime: 5, blackTime: 18, whiteConfidence: 96, blackConfidence: 2, whiteStress: 6, blackStress: 99, whiteAccuracy: 96, blackAccuracy: 2 },
      { move: 25, whiteTime: 6, blackTime: 23, whiteConfidence: 98, blackConfidence: 2, whiteStress: 4, blackStress: 99, whiteAccuracy: 98, blackAccuracy: 2 },
      { move: 26, whiteTime: 8, blackTime: 12, whiteConfidence: 97, blackConfidence: 1, whiteStress: 5, blackStress: 100, whiteAccuracy: 97, blackAccuracy: 1 },
      { move: 27, whiteTime: 6, blackTime: 18, whiteConfidence: 98, blackConfidence: 1, whiteStress: 4, blackStress: 100, whiteAccuracy: 98, blackAccuracy: 1 },
      { move: 28, whiteTime: 6, blackTime: 8, whiteConfidence: 99, blackConfidence: 1, whiteStress: 3, blackStress: 100, whiteAccuracy: 99, blackAccuracy: 1 },
      { move: 29, whiteTime: 8, blackTime: 10, whiteConfidence: 98, blackConfidence: 1, whiteStress: 4, blackStress: 100, whiteAccuracy: 98, blackAccuracy: 1 },
      { move: 30, whiteTime: 6, blackTime: 38, whiteConfidence: 97, blackConfidence: 1, whiteStress: 5, blackStress: 100, whiteAccuracy: 97, blackAccuracy: 1 },
      { move: 31, whiteTime: 7, blackTime: 37, whiteConfidence: 98, blackConfidence: 1, whiteStress: 4, blackStress: 100, whiteAccuracy: 98, blackAccuracy: 1 },
      { move: 32, whiteTime: 6, blackTime: 25, whiteConfidence: 99, blackConfidence: 0, whiteStress: 3, blackStress: 100, whiteAccuracy: 99, blackAccuracy: 0 },
      { move: 33, whiteTime: 10, blackTime: 12, whiteConfidence: 98, blackConfidence: 0, whiteStress: 4, blackStress: 100, whiteAccuracy: 98, blackAccuracy: 0 },
      { move: 34, whiteTime: 7, blackTime: 51, whiteConfidence: 99, blackConfidence: 0, whiteStress: 3, blackStress: 100, whiteAccuracy: 99, blackAccuracy: 0 },
      { move: 35, whiteTime: 7, blackTime: 6, whiteConfidence: 100, blackConfidence: 0, whiteStress: 2, blackStress: 100, whiteAccuracy: 100, blackAccuracy: 0 },
      { move: 36, whiteTime: 9, blackTime: 13, whiteConfidence: 99, blackConfidence: 0, whiteStress: 3, blackStress: 100, whiteAccuracy: 99, blackAccuracy: 0 },
      { move: 37, whiteTime: 9, blackTime: 8, whiteConfidence: 100, blackConfidence: 0, whiteStress: 2, blackStress: 100, whiteAccuracy: 100, blackAccuracy: 0 },
      { move: 38, whiteTime: 8, blackTime: 19, whiteConfidence: 99, blackConfidence: 0, whiteStress: 3, blackStress: 100, whiteAccuracy: 99, blackAccuracy: 0 },
      { move: 39, whiteTime: 8, blackTime: 12, whiteConfidence: 100, blackConfidence: 0, whiteStress: 2, blackStress: 100, whiteAccuracy: 100, blackAccuracy: 0 },
      { move: 40, whiteTime: 6, blackTime: 13, whiteConfidence: 100, blackConfidence: 0, whiteStress: 1, blackStress: 100, whiteAccuracy: 100, blackAccuracy: 0 },
      { move: 41, whiteTime: 7, blackTime: 0, whiteConfidence: 100, blackConfidence: 0, whiteStress: 0, blackStress: 100, whiteAccuracy: 100, blackAccuracy: 0 }
    ],
    errors: [
      {
        move: 10,
        player: "black",
        severity: 3,
        type: "tactical",
        description: "Ход Nd5 позволяет белым получить решающее преимущество",
        betterMove: "exf5",
        evaluation: "Потеря пешки и ухудшение позиции короля"
      }
    ],
    keyMoments: [
      {
        move: 10,
        event: "Тактический просмотр черных",
        significance: "critical",
        impact: "Начало решающей атаки белых"
      }
    ],
    conclusions: {
      whiteStrengths: [
        "Отличное использование тактических возможностей",
        "Последовательная реализация преимущества"
      ],
      blackWeaknesses: [
        "Слабая защита короля",
        "Тактические просмотры"
      ],
      gamePhases: {
        opening: "Белые получили инициативу после неточностей черных в дебюте",
        middlegame: "Решающая атака белых на королевском фланге",
        endgame: "Техничная реализация материального перевеса"
      },
      turningPoint: {
        move: 10,
        description: "После хода f5 позиция черных стала критической"
      }
    },
    ui: {
      title: "Анализ шахматной партии",
      subtitle: "Психологический и тактический анализ",
      gameInfo: {
        players: "Игроки",
        gameTime: "Время партии",
        duration: "Продолжительность",
        timeControl: "Контроль времени",
        gameId: "ID партии",
        gameType: "Тип партии",
        hintsUsed: "Использовано подсказок"
      },
      stats: {
        whiteAccuracy: "Точность белых",
        blackAccuracy: "Точность черных",
        totalMoves: "Всего ходов",
        criticalErrors: "Критические ошибки",
        longestThink: "Самое долгое размышление",
        timeSpent: "Затраченное время",
        move: "Ход"
      },
      tabs: [
        { id: "confidence", label: "Уверенность", icon: "TrendingUp" },
        { id: "stress", label: "Стресс", icon: "AlertTriangle" },
        { id: "time", label: "Время на ход", icon: "Clock" },
        { id: "accuracy", label: "Точность", icon: "CheckCircle" }
      ],
      chartTitles: {
        confidence: "График уверенности",
        stress: "График уровня стресса",
        time: "График времени на ход",
        accuracy: "График точности ходов"
      },
      charts: {
        whiteConfidence: "Уверенность белых",
        blackConfidence: "Уверенность черных",
        whiteStress: "Стресс белых",
        blackStress: "Стресс черных",
        whiteTime: "Время белых (сек)",
        blackTime: "Время черных (сек)",
        whiteAccuracy: "Точность белых (%)",
        blackAccuracy: "Точность черных (%)"
      },
      sections: {
        keyMoments: "Ключевые моменты",
        errorAnalysis: "Анализ ошибок",
        conclusions: "Выводы",
        gamePhases: "Фазы партии"
      },
      players: { white: "Белые", black: "Черные" },
      errorTypes: { "1": "Неточность", "2": "Ошибка", "3": "Грубая ошибка", "4": "Критическая ошибка" },
      significance: {
        critical: "Критический",
        tactical: "Тактический",
        strategic: "Стратегический",
        decisive: "Решающий",
        phase_transition: "Переход фазы"
      },
      conclusions: {
        whiteStrengths: "Сильные стороны белых",
        blackWeaknesses: "Слабые стороны черных"
      },
      phases: { opening: "Дебют", middlegame: "Миттельшпиль", endgame: "Эндшпиль" },
      moveLabel: "ход",
      betterMove: "Лучший ход",
      turningPoint: "Переломный момент"
    }
  };

  const getSeverityColor = (severity) => {
    const colors = { 1: '#fbbf24', 2: '#f97316', 3: '#ef4444', 4: '#dc2626' };
    return colors[severity] || '#6b7280';
  };

  const getSignificanceColor = (significance) => {
    const colors = {
      critical: 'bg-red-900 text-red-200',
      tactical: 'bg-blue-900 text-blue-200',
      strategic: 'bg-green-900 text-green-200',
      decisive: 'bg-purple-900 text-purple-200',
      phase_transition: 'bg-gray-600 text-gray-200'
    };
    return colors[significance] || 'bg-gray-600 text-gray-200';
  };

  const getPlayerColor = (player) => player === 'white' ? 'text-blue-400' : 'text-red-400';

  const formatDateTime = (dateString) => {
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  const renderChart = () => {
    const chartConfig = {
      confidence: {
        lines: [
          { dataKey: 'whiteConfidence', stroke: '#3b82f6', name: gameData.ui.charts.whiteConfidence },
          { dataKey: 'blackConfidence', stroke: '#ef4444', name: gameData.ui.charts.blackConfidence }
        ]
      },
      stress: {
        areas: [
          { dataKey: 'whiteStress', stackId: '1', stroke: '#8b5cf6', fill: '#8b5cf6', name: gameData.ui.charts.whiteStress },
          { dataKey: 'blackStress', stackId: '2', stroke: '#f59e0b', fill: '#f59e0b', name: gameData.ui.charts.blackStress }
        ]
      },
      time: {
        bars: [
          { dataKey: 'whiteTime', fill: '#3b82f6', name: gameData.ui.charts.whiteTime },
          { dataKey: 'blackTime', fill: '#ef4444', name: gameData.ui.charts.blackTime }
        ]
      },
      accuracy: {
        lines: [
          { dataKey: 'whiteAccuracy', stroke: '#10b981', name: gameData.ui.charts.whiteAccuracy },
          { dataKey: 'blackAccuracy', stroke: '#f59e0b', name: gameData.ui.charts.blackAccuracy }
        ]
      }
    };

    const config = chartConfig[activeTab];
    if (!config) return null;

    const commonProps = {
      data: gameData.moveData,
      children: [
        <CartesianGrid key="grid" strokeDasharray="3 3" stroke="#374151" />,
        <XAxis key="xaxis" dataKey="move" stroke="#9ca3af" />,
        <YAxis key="yaxis" stroke="#9ca3af" />,
        <Tooltip key="tooltip" contentStyle={{ backgroundColor: '#1f2937', border: '1px solid #374151', borderRadius: '8px', color: '#f9fafb' }} />,
        <Legend key="legend" />
      ]
    };

    switch (activeTab) {
      case 'confidence':
      case 'accuracy':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <LineChart {...commonProps}>
              {commonProps.children}
              {config.lines.map((line, index) => (
                <Line key={index} type="monotone" dataKey={line.dataKey} stroke={line.stroke} strokeWidth={3} name={line.name} dot={{ fill: line.stroke, strokeWidth: 2, r: 4 }} />
              ))}
            </LineChart>
          </ResponsiveContainer>
        );
      case 'stress':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <AreaChart {...commonProps}>
              {commonProps.children}
              {config.areas.map((area, index) => (
                <Area key={index} type="monotone" dataKey={area.dataKey} stackId={area.stackId} stroke={area.stroke} fill={area.fill} fillOpacity={0.6} name={area.name} />
              ))}
            </AreaChart>
          </ResponsiveContainer>
        );
      case 'time':
        return (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart {...commonProps}>
              {commonProps.children}
              {config.bars.map((bar, index) => (
                <Bar key={index} dataKey={bar.dataKey} fill={bar.fill} name={bar.name} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        );
      default:
        return null;
    }
  };

  const { gameMetadata, statistics, errors, keyMoments, ui, conclusions } = gameData;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900">
      {/* Chess board pattern overlay */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="w-full h-full" style={{
       
          backgroundSize: '60px 60px',
          backgroundPosition: '0 0, 0 30px, 30px -30px, -30px 0px'
        }} />
      </div>
      
      <div className="relative z-10 text-white p-3 sm:p-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-4xl font-bold text-center mb-2 sm:mb-4 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
              {ui.title}
            </h1>
            <div className="text-center text-gray-300">
              <p className="text-sm sm:text-lg mb-1 sm:mb-2">{ui.subtitle}</p>
              <p className="text-xs sm:text-base">{gameMetadata.opening} • {gameMetadata.result}</p>
            </div>
          </div>

          {/* Game Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-3 sm:p-4 border border-gray-700">
              <div className="flex items-center gap-2 sm:gap-3">
                <User className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400" />
                <div>
                  <p className="text-gray-400 text-xs">{ui.gameInfo.players}</p>
                  <p className="text-xs sm:text-sm font-medium text-blue-400 truncate">{gameMetadata.whitePlayer}</p>
                  <p className="text-xs sm:text-sm font-medium text-red-400 truncate">{gameMetadata.blackPlayer}</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-3 sm:p-4 border border-gray-700">
              <div className="flex items-center gap-2 sm:gap-3">
                <Calendar className="w-4 h-4 sm:w-5 sm:h-5 text-green-400" />
                <div>
                  <p className="text-gray-400 text-xs">{ui.gameInfo.gameTime}</p>
                  <p className="text-xs sm:text-sm font-medium">{formatDateTime(gameMetadata.startTime)}</p>
                  <p className="text-xs text-gray-500">{ui.gameInfo.duration}: {gameMetadata.duration}</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-3 sm:p-4 border border-gray-700">
              <div className="flex items-center gap-2 sm:gap-3">
                <Timer className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" />
                <div>
                  <p className="text-gray-400 text-xs">{ui.gameInfo.timeControl}</p>
                  <p className="text-xs sm:text-sm font-medium">{gameMetadata.gameType}</p>
                  <p className="text-xs text-gray-500">{ui.gameInfo.gameId}: {gameMetadata.gameId.slice(0, 8)}...</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-3 sm:p-4 border border-gray-700">
              <div className="flex items-center gap-2 sm:gap-3">
                <Gamepad2 className="w-4 h-4 sm:w-5 sm:h-5 text-purple-400" />
                <div>
                  <p className="text-gray-400 text-xs">{ui.gameInfo.gameType}</p>
                  <p className="text-xs sm:text-sm font-medium">{gameMetadata.userType} vs {gameMetadata.opponentType}</p>
                  <p className="text-xs text-gray-500">{ui.gameInfo.hintsUsed}: {gameMetadata.usedHints}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Statistics Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-6 mb-6 sm:mb-8">
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">{ui.stats.whiteAccuracy}</p>
                  <p className="text-xl sm:text-2xl font-bold text-blue-400">{statistics.whiteAccuracy}%</p>
                </div>
                <TrendingUp className="w-6 h-6 sm:w-8 sm:h-8 text-blue-400" />
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">{ui.stats.blackAccuracy}</p>
                  <p className="text-xl sm:text-2xl font-bold text-red-400">{statistics.blackAccuracy}%</p>
                </div>
                <TrendingDown className="w-6 h-6 sm:w-8 sm:h-8 text-red-400" />
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">{ui.stats.totalMoves}</p>
                  <p className="text-xl sm:text-2xl font-bold text-green-400">{statistics.totalMoves}</p>
                </div>
                <Clock className="w-6 h-6 sm:w-8 sm:h-8 text-green-400" />
              </div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">{ui.stats.criticalErrors}</p>
                  <p className="text-xl sm:text-2xl font-bold text-yellow-400">{statistics.criticalErrors}</p>
                </div>
                <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-400" />
              </div>
            </div>
          </div>

          {/* Chart Tabs */}
          <div className="mb-4 sm:mb-6">
            <div className="flex flex-wrap gap-1 sm:gap-2 overflow-x-auto pb-2">
              {ui.tabs.map(tab => {
                const iconMap = { TrendingUp, AlertTriangle, Clock, CheckCircle };
                const IconComponent = iconMap[tab.icon] || TrendingUp;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-1 sm:gap-2 px-3 sm:px-4 py-2 rounded-lg transition-colors whitespace-nowrap ${
                      activeTab === tab.id ? 'bg-blue-600 text-white' : 'bg-gray-800/80 text-gray-300 hover:bg-gray-700'
                    }`}
                  >
                    <IconComponent className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="text-xs sm:text-sm">{tab.label}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Chart with Scroll - FIXED */}
          <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 mb-6 sm:mb-8 border border-gray-700">
            <h2 className="text-lg sm:text-xl font-semibold mb-4 text-center">{ui.chartTitles[activeTab]}</h2>
            
            {/* Horizontal scroll container with visible scrollbar */}
            <div className="w-full overflow-x-auto overflow-y-hidden" style={{ scrollbarWidth: 'thin' }}>
              <div className="min-w-[800px] w-full" style={{ width: `${Math.max(800, gameData.moveData.length * 20)}px` }}>
                <div className="h-[300px] sm:h-[400px]">
                  {renderChart()}
                </div>
              </div>
            </div>
            
            {/* Scroll hint for mobile */}
            <div className="text-center mt-2 sm:hidden">
              <p className="text-xs text-gray-400">← Прокрутите для просмотра всех ходов →</p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-8">
            {/* Key Moments */}
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <h3 className="text-lg sm:text-xl font-semibold mb-4 flex items-center gap-2">
                <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400" />
                {ui.sections.keyMoments}
              </h3>
              <div className="space-y-3 max-h-80 overflow-y-auto">
                {keyMoments.map((moment, index) => (
                  <div key={index} className="flex items-start gap-3 p-3 bg-gray-700/50 rounded-lg">
                    <div className="text-blue-400 font-bold text-sm min-w-[3rem]">{moment.move}{ui.moveLabel}</div>
                    <div className="flex-1">
                      <p className="text-white text-sm">{moment.event}</p>
                      <span className={`inline-block px-2 py-1 rounded text-xs mt-1 ${getSignificanceColor(moment.significance)}`}>
                        {ui.significance[moment.significance]}
                      </span>
                      {moment.impact && <p className="text-gray-400 text-xs mt-1">{moment.impact}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Error Analysis */}
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
              <h3 className="text-lg sm:text-xl font-semibold mb-4 flex items-center gap-2">
                <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" />
                {ui.sections.errorAnalysis}
              </h3>
              <div className="space-y-2 max-h-80 overflow-y-auto">
                {errors.map((error, index) => (
                  <div key={index} className="flex items-start gap-3 p-3 bg-gray-700/50 rounded-lg">
                    <div className="flex items-center gap-2 min-w-[3rem] sm:min-w-[5rem]">
                      <span className="text-gray-300 text-sm font-medium">{error.move}{ui.moveLabel}</span>
                      <div className="w-3 h-3 rounded-full" style={{ backgroundColor: getSeverityColor(error.severity) }} />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-wrap items-center gap-2 mb-1">
                        <span className={`text-sm font-medium ${getPlayerColor(error.player)}`}>{ui.players[error.player]}</span>
                        <span className="text-xs px-2 py-1 rounded" style={{ backgroundColor: getSeverityColor(error.severity) + '33', color: getSeverityColor(error.severity) }}>
                          {ui.errorTypes[error.severity]}
                        </span>
                      </div>
                      <p className="text-gray-300 text-sm">{error.description}</p>
                      {error.betterMove && <p className="text-green-400 text-xs mt-1">{ui.betterMove}: {error.betterMove}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Game Phases */}
          <div className="mt-6 sm:mt-8 bg-gray-800/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-700">
            <h3 className="text-lg sm:text-xl font-semibold mb-4">{ui.sections.gamePhases}</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
              <div className="bg-gray-700/50 p-4 rounded-lg">
                <h4 className="font-semibold text-green-400 mb-2">{ui.phases.opening}</h4>
                <p className="text-gray-300 text-sm">{conclusions.gamePhases.opening}</p>
              </div>
              <div className="bg-gray-700/50 p-4 rounded-lg">
                <h4 className="font-semibold text-blue-400 mb-2">{ui.phases.middlegame}</h4>
                <p className="text-gray-300 text-sm">{conclusions.gamePhases.middlegame}</p>
              </div>
              <div className="bg-gray-700/50 p-4 rounded-lg">
                <h4 className="font-semibold text-purple-400 mb-2">{ui.phases.endgame}</h4>
                <p className="text-gray-300 text-sm">{conclusions.gamePhases.endgame}</p>
              </div>
            </div>
          </div>

          {/* Conclusions */}
          <div className="mt-6 sm:mt-8 bg-gradient-to-r from-gray-800/80 to-gray-700/80 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-gray-600">
            <h3 className="text-lg sm:text-xl font-semibold mb-4 text-center">{ui.sections.conclusions}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <h4 className="font-semibold text-blue-400 mb-2">{ui.conclusions.whiteStrengths}:</h4>
                <ul className="text-gray-300 text-sm space-y-1">
                  {conclusions.whiteStrengths.map((strength, index) => (
                    <li key={index}>• {strength}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-red-400 mb-2">{ui.conclusions.blackWeaknesses}:</h4>
                <ul className="text-gray-300 text-sm space-y-1">
                  {conclusions.blackWeaknesses.map((weakness, index) => (
                    <li key={index}>• {weakness}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Turning Point */}
            <div className="mt-4 sm:mt-6 bg-gray-600/50 p-4 rounded-lg">
              <h4 className="font-semibold text-yellow-400 mb-2">{ui.turningPoint}:</h4>
              <p className="text-gray-300 text-sm">
                <span className="font-medium">{ui.stats.move} {conclusions.turningPoint.move}:</span> {conclusions.turningPoint.description}
              </p>
            </div>
          </div>

          {/* Mobile-friendly bottom spacing */}
          <div className="h-4 sm:h-8"></div>
        </div>
      </div>
    </div>
  );
};

export default ChessAnalysisDisplay;